import Echo from 'laravel-echo';
// import "livewire-sortable";
import "./tailwind-components";
import "./image-downscale";
import guardEchoChannelAuth from './echo-auth-guard';
import smoothscroll from 'smoothscroll-polyfill';
import $ from 'jquery';
import 'select2';
import 'flatpickr';


window.jQuery = $;
window.$ = $;

smoothscroll.polyfill();

window.Pusher = require('pusher-js');

let pusher_key = document.head.querySelector('meta[name="pusher-key"]');
let reverb_key = document.head.querySelector('meta[name="reverb-key"]');
if (pusher_key) {
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: pusher_key.content,
    wsHost: 'realtime-pusher.ably.io',
    wsPort: 443,
    encrypted: true,
    authEndpoint: '/app/broadcasting/auth',
    disableStats: true,
    cluster: 'eu',
  });
}
else if(reverb_key){
  window.Echo = new Echo({
    broadcaster: 'reverb',
    key: reverb_key.content,
    authEndpoint: '/app/broadcasting/auth',
    wsHost: document.head.querySelector('meta[name="reverb-host"]').content,
    wsPort: document.head.querySelector('meta[name="reverb-port"]').content,
    wssPort: document.head.querySelector('meta[name="reverb-port"]').content,
    forceTLS: document.head.querySelector('meta[name="reverb-scheme"]').content === 'https',
    enabledTransports: ['ws', 'wss'],
    wsPath: '/ws',
  });
}
else{
  console.error('Broadcaster key not found');
}

if (window.Echo) {
  guardEchoChannelAuth(window.Echo);
}

window.document.onload = function(e) {
  /**
   * Animations in livewire lists
   */
  let animations = []
  Livewire.hook('message.received', () => {
    let things = Array.from(document.querySelectorAll('[animate-move]'))
    animations = things.map(thing => {
      let oldTop = thing.getBoundingClientRect().top

      return () => {
        let newTop = thing.getBoundingClientRect().top

        thing.animate([
          {transform: `translateY(${oldTop - newTop}px)`},
          {transform: `translateY(0px)`},
        ], {duration: 1000, easing: 'ease'})
      }
    })

    things.forEach(thing => {
      thing.getAnimations().forEach(animation => animation.finish())
    })
  })

  Livewire.hook('message.processed', () => {
    while (animations.length) {
      animations.shift()()
    }
  })

}